/**
 * Stores build information about <b>this specific version of the `ruffle-core` library</b>.
 *
 * It does not represent the version of Ruffle that may be in use by the page (for example, if a browser extension overrides it).
 *
 * @privateRemarks
 * This is generated at build time via `set_version.ts`.
 */
export const buildInfo = {
    versionNumber: "0.7.0-nightly.2026.9.22",
    versionName: "0.7.0-nightly.2026.9.22",
    versionChannel: "nightly",
    buildDate: "2026-09-22T00:17:30.301Z",
    commitHash: "5155c40e23f8b691bb5e7937c5e49719c01979e1",
};
